// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GridViewRenderer .jqx-grid {
    position: absolute;
	box-sizing: border-box;
}
.GridViewRenderer .jqx-grid-cell .cell-content {
	position: relative;
    padding: 0.25rem;
	box-sizing: border-box;
}
.GridViewRenderer .jqx-grid table {
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color);
}
.GridViewRenderer .jqx-grid table tr:nth-child(odd) {
	background-color: var(--bs-light-bg-subtle);
}
.GridViewRenderer .jqx-grid table tr:nth-child(even) {
    background-color: var(--bs-gray-200);
}
.GridViewRenderer .jqx-grid table td.key {
    width: 20%;
}
.GridViewRenderer .jqx-grid-cell {
	color: unset !important;
	background-color: var(--bs-gray-100) !important;
	outline: unset !important;
}
.GridViewRenderer .jqx-grid-cell-selected-bootstrap {
	background-color: var(--bs-gray-400) !important;
	border-color: var(--bs-gray-500) !important;
}
.GridViewRenderer .jqx-grid-cell-hover-bootstrap {
	background-color: var(--bs-gray-200) !important;
}
.GridViewRenderer .subtable td{
	padding: 0.125rem 0.5rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
